<template>
    <div class="form-control-root cic-select">
        <label v-if="label" :for="inputId" class="form-control-label">{{ label }}</label>
        <div class="form-control-input">
            <LoadingBalls v-if="!!loading" />
            <el-select
                v-else
                :model-value="value"
                :multiple="!!multiple"
                v-bind="Object.assign(JSON.parse(JSON.stringify($attrs)), { id: inputId })"
                filterable
                @update:modelValue="(val) => $emit('input', val)"
            >
                <el-option v-for="option in options" :key="option.value" :label="option.label" :value="option.value">
                    {{ option.label }}
                </el-option>
            </el-select>
        </div>
    </div>
</template>

<script>
    import { ElSelect, ElOption } from 'element-plus';
    import { LoadingBalls } from '@/components/container';

    export default {
        name: 'SelectInput',
        components: {
            LoadingBalls,
            'el-select': ElSelect,
            'el-option': ElOption,
        },
        props: {
            inputId: {
                type: String,
                default: undefined,
            },
            label: {
                type: String,
                default: undefined,
            },
            loading: {
                type: Boolean,
                default: undefined,
            },
            multiple: {
                type: Boolean,
                default: undefined,
            },
            options: {
                type: Array,
                required: true,
            },
            value: {
                type: [Number, String, Array],
                default: null,
            },
        },
        emits: ['input'],
    };
</script>
